import React, { useContext, useMemo } from 'react';
import { Notification } from '../../../../../models';
import classes from './Engagement.module.scss';
import { AppTableContext } from '../../../../AppTable/AppTableContext';
import { withRowActions } from '../../../../AppTable/helpers/withRowActions';
import { withSkeleton } from '../../../../AppTable/helpers/withSkeleton';

const Engagement = ({ rowData: notification }: { rowData: Notification }) => {
    const { tableDataTestid } = useContext(AppTableContext);

    const renderClicks = useMemo(() => {
        if (notification.analytics?.clicks) {
            return notification.analytics?.clicks;
        }

        return notification.analytics?.views ? '0' : '-';
    }, [notification.analytics?.clicks, notification.analytics?.views]);

    return (
        <div className={classes.engagement} data-testid={`${notification.id}-engagement-${tableDataTestid}`}>
            {renderClicks}
        </div>
    );
};

export default withSkeleton({ height: 20, width: 55, style: { margin: 'auto' } })(withRowActions(Engagement));
